import type { Hunt } from './types'

/**
 * Orders pending invitations newest first by `invitedAt`. One without it goes
 * after every dated invitation, and those are ordered by the hunt's start,
 * soonest first. The mobile app orders its invitation lists by the same rule,
 * so both clients show the same list in the same order.
 */
export function compareInvitesNewestFirst(a: Hunt, b: Hunt): number {
  const aSent = a.invitedAt ? Date.parse(a.invitedAt) : NaN
  const bSent = b.invitedAt ? Date.parse(b.invitedAt) : NaN
  const aDated = !Number.isNaN(aSent)
  const bDated = !Number.isNaN(bSent)
  if (aDated && bDated && aSent !== bSent) return bSent - aSent
  if (aDated !== bDated) return aDated ? -1 : 1
  // date and start are zero-padded local strings, so they compare as text.
  const aStart = `${a.date}T${a.start}`
  const bStart = `${b.date}T${b.start}`
  if (aStart !== bStart) return aStart < bStart ? -1 : 1
  // Code-unit order, as the app's tie-break uses, not localeCompare.
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0
}
